/**
 * @returns {Number}
 */
function checkIfIsAnimating() {
  return $(':animated').length;
}

/**
 *
 */
export function expandTable() {
  if (checkIfIsAnimating()) {
    return;
  }

  const $wrapperAllTables = $(this).prev('.wrapper-all-tables');
  const $tableRemainingRows = $wrapperAllTables.find('.table-remaining-rows');

  if ($(this).hasClass('expanded')) {
    $('.table-row').removeClass('table-row-active')
      .find('.info').removeClass('open');

    $wrapperAllTables.find('.row-details').slideUp();
    $tableRemainingRows.slideUp(() => {
      $(this).removeClass('expanded');
      $(this).children('.expand-table-text').html('expandir tabela completa');
    });
  } else {
    // if (ga) {
    //   const year = $('.container-f1').attr('data-year');
    //   const tableName = $(this).prev().attr('data-table');
    //   const whichTable = tableName === 'pilotos' ? 'Pilotos' : 'Construtores';
    //   ga('send', 'event', `formula 1 ${year}`, whichTable, 'Ver mais');
    // }

    $tableRemainingRows.slideDown(() => {
      $(this).children('.expand-table-text').html('voltar');
      $(this).addClass('expanded');
    });
  }
}

/**
 *
 */
export function expandDetails() {
  if (checkIfIsAnimating()) {
    return;
  }

  const $thisTableRow = $(this);
  const $otherRowsInThisTable = $(this).siblings('.table-row');
  const $parentTable = $thisTableRow.parent('.table-default-skin');
  const $otherTable = $parentTable.siblings('.table-default-skin');
  const $otherTableRows = $otherTable.find('.table-row');
  const rowIndex = $(this).attr('data-row');
  const $rowDetails = $parentTable.find(`.row-details-${rowIndex}`);

  $otherRowsInThisTable.next('.row-details').slideUp({ queue: false });
  $otherRowsInThisTable.removeClass('table-row-active');
  $otherRowsInThisTable.find('.info').removeClass('open');

  $otherTableRows.next('.row-details').slideUp({ queue: false });
  $otherTableRows.removeClass('table-row-active');
  $otherTableRows.find('.info').removeClass('open');

  if ($(this).hasClass('table-row-active')) {
    $thisTableRow.find('.info').removeClass('open');
    $rowDetails.slideUp({
      queue: false,
      complete() {
        $thisTableRow.removeClass('table-row-active');
      },
    });
  } else {
    $thisTableRow.addClass('table-row-active');
    $thisTableRow.find('.info').addClass('open');
    $rowDetails.slideDown({ queue: false });

    // if (ga) {
    //   const year = $('.container-f1').attr('data-year');
    //   const dataPilot = $thisTableRow.attr('data-pilot');
    //   const dataConstructor = $thisTableRow.attr('data-constructor');
    //   const tableData = dataPilot || dataConstructor;
    //   const itemPrefix = dataPilot ? 'piloto-' : 'equipe-';
    //   ga('send', 'event', `formula 1 ${year}`, itemPrefix + tableData, 'ver informacoes');
    // }
  }
}



// WEBPACK FOOTER //
// local_static/templates/motor/2017/assets/scripts/tables.js